import React from 'react';
import classes from './FilterItemGroup.module.scss';
import { WithChildren } from '../../../models/children-props';
import classNames from 'classnames';

export type FilterItemGroupViewProps = WithChildren<{
  title: string;
  resetHandler?: VoidFunction;
  isFiltered?: boolean;
  clearText?: string
}>;

export const FilterItemGroupView = (props: FilterItemGroupViewProps): JSX.Element => {
  const onClickHandler = props?.resetHandler ?? false;

  return (
    <form className={classes.FilterMenuGroup}>
      <div className={'padding-bottom-small-24'}>
        <div className={'grid-x align-justify'}>
          <div className={'cell shrink margin-bottom-small-12'}>
            <h6 className={classNames(classes.Title, 'uppercase')}>{props.title}</h6>
          </div>
          {onClickHandler && props.isFiltered && (
            <div className={'cell shrink margin-bottom-small-12'}>
              <h6 className={classNames(classes.ClearLink, 'uppercase')} onClick={() => onClickHandler()}>
                {props.clearText ?? 'Clear All'}
              </h6>
            </div>
          )}
        </div>
        <div>{props.children}</div>
      </div>
    </form>
  );
};
